import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import { useAppDispatch } from "../../../../hooks/useRedux";
import boxonwheel from "../../../../media/images/boxonwheel.png";
import delivery from "../../../../media/images/delivery-tracking.png";
import driverDashboard_bg from "../../../../media/images/driverDashboard_bg.svg";
import AddSimpleSVG from "../../../../media/images/icons/add-simple";
import ArrowLeftSVG from "../../../../media/images/icons/arrow-left";
import manageBoll from "../../../../media/images/manage-bols.png";
import monyCoins from "../../../../media/images/mony-coins.png";
import { setOwnerInfo } from "../../../../redux/features/ownerSlice";
import { fetcherPost } from "../../../../services/fetcher";
import DashboardHeader from "./Header";

export default function OwnerDashboardPage() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { trigger: getOwnerInfo } = useSWRMutation(
    [`/Driver/GetOwnerUserInfo`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: async (data) => {
        dispatch(setOwnerInfo(data));
      },
    }
  );
  useEffect(() => {
    getOwnerInfo({});
  }, []);

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          width: "100%",
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `
         url(${driverDashboard_bg})
         `,
          backgroundColor: "#0D4884",
          paddingX: "8px",
          paddingY: "8px",
          overflow: "auto",
        }}
      >
        <DashboardHeader />

        <Box sx={{ flexGrow: 1, mt: 2, width: "100%" }}>
          <Grid
            container
            sx={{
              display: "flex",
              // gap: 2,
              justifyContent: "space-between",
            }}
          >
            <Grid
              item
              xs={6.3}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <Button
                onClick={() => navigate("../add-order")}
                sx={{
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                  border: "1px solid gray",
                  padding: "0px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: "130px",
                    width: "100%",
                    backgroundColor: "success.main",
                    backgroundImage: `
                      url(${boxonwheel})
                      `,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "120px",
                    backgroundPosition: "80% 50%",
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "relative",
                    paddingY: "8px",
                    paddingX: "8px",
                    width: "100%",
                    textAlign: "right",
                    backgroundColor: "bgColor.white",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      left: "8px",
                      width: "40px",
                      border: "1px solid white",
                      backgroundColor: "secondary.main",
                      borderRadius: "20px",
                      display: "flex",
                      boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
                      justifyContent: "center",
                    }}
                  >
                    <AddSimpleSVG size={28} color="#fff" />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                    color="secondary.main"
                  >
                    ثبت سفارش
                  </Typography>
                </Box>
              </Button>
              <Button
                onClick={() => navigate("../manage-orders")}
                sx={{
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                  border: "1px solid gray",
                  padding: "0px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: "120px",
                    width: "100%",
                    backgroundColor: blueGrey[100],
                    backgroundImage: `
                      url(${delivery})
                      `,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "150px",
                    backgroundPosition: "80% 50%",
                  }}
                ></Box>
                <Box
                  sx={{
                    backgroundColor: blueGrey[100],
                    width: "100%",
                    paddingX: "8px",
                    paddingY: "4px",
                    display: "flex",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "600",
                    }}
                    color={grey[800]}
                  >
                    مدیریت،لغو ...
                  </Typography>
                </Box>
                <Box
                  sx={{
                    position: "relative",
                    paddingY: "8px",
                    paddingX: "8px",
                    width: "100%",
                    textAlign: "right",
                    backgroundColor: "bgColor.white",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      left: "8px",
                      width: "40px",
                      border: "1px solid white",
                      backgroundColor: "secondary.main",
                      borderRadius: "20px",
                      display: "flex",
                      boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowLeftSVG size={28} color="#fff" />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                    color="secondary.main"
                  >
                    مدیریت سفارشات{" "}
                  </Typography>
                </Box>
              </Button>
            </Grid>
            <Grid
              item
              xs={5.3}
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <Button
                onClick={() => navigate("../bols-histories")}
                sx={{
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                  border: "1px solid gray",
                  padding: "0px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: "80px",
                    width: "100%",
                    backgroundColor: blueGrey[100],
                    backgroundImage: `
                      url(${manageBoll})
                      `,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100px",
                    backgroundPosition: "50% 10%",
                  }}
                ></Box>
                <Box
                  sx={{
                    position: "relative",
                    paddingY: "8px",
                    paddingX: "8px",
                    width: "100%",
                    textAlign: "right",
                    backgroundColor: "bgColor.white",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      left: "8px",
                      width: "40px",
                      border: "1px solid white",
                      backgroundColor: "secondary.main",
                      borderRadius: "20px",
                      display: "flex",
                      boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowLeftSVG size={28} color="#fff" />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "3px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                      color="secondary.main"
                    >
                      سوابق بارنامه‌
                    </Typography>
                    <Divider variant="fullWidth" />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                      color="secondary.main"
                    >
                      پرداخت کرایه
                    </Typography>
                  </Box>
                </Box>
              </Button>
              <Button
                onClick={() => navigate("../wallet")}
                sx={{
                  width: "100%",
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                  border: "1px solid gray",
                  padding: "0px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: "80px",
                    width: "100%",
                    backgroundColor: blueGrey[100],
                    backgroundImage: `
                      url(${monyCoins})
                      `,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100px",
                    backgroundPosition: "50% 50%",
                  }}
                ></Box>

                <Box
                  sx={{
                    position: "relative",
                    paddingY: "8px",
                    paddingX: "8px",
                    width: "100%",
                    textAlign: "right",
                    backgroundColor: "bgColor.white",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      left: "8px",
                      width: "30px",
                      height: "30px",
                      border: "1px solid white",
                      backgroundColor: "#1577DA",
                      borderRadius: "50%",
                      display: "flex",
                      boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ArrowLeftSVG size={26} color="#fff" />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                    color="#105DAA"
                  >
                    کیف پول{" "}
                  </Typography>
                </Box>
              </Button>
              {/* <Button
                onClick={() => navigate("../profile")}
                sx={{
                  width: "100%",
                  color: `#fff !important`,
                  borderWidth: "0px !important",
                  border: "1px solid gray",
                  padding: "0px",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    height: "80px",
                    width: "100%",
                    backgroundColor: blueGrey[100],
                    backgroundImage: `
                      url(${contact})
                      `,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "100px",
                    backgroundPosition: "50% 50%",
                  }}
                ></Box>

                <Box
                  sx={{
                    position: "relative",
                    paddingY: "8px",
                    paddingX: "8px",
                    width: "100%",
                    textAlign: "right",
                    backgroundColor: "bgColor.white",
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "-20px",
                      left: "8px",
                      width: "30px",
                      height: "30px",
                      border: "1px solid white",
                      backgroundColor: "#1577DA",
                      borderRadius: "50%",
                      display: "flex",
                      boxShadow: "0px 2px 5px 0px rgba(0,0,0,0.2)",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <ArrowLeftSVG size={26} color="#fff" />
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: "700",
                    }}
                    color="#105DAA"
                  >
                    مشخصات حساب{" "}
                  </Typography>
                </Box>
              </Button> */}
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
